"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
var idGenerator_1 = require("spry-react/utils/idGenerator");
var fieldLabel_1 = require("spry-react/Label/fieldLabel");
var link_1 = require("spry-react/Link/link");
var recompose_1 = require("recompose");
function lockToggle(Component) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.generatedId = idGenerator_1.GenerateId();
                return _this;
            }
            class_1.prototype.render = function () {
                var _this = this;
                var iconClass = classnames('l-box-hl-1-2x', {
                    'edit-icon': this.props.valueIsLocked,
                    'lock-icon': !this.props.valueIsLocked,
                    'disabled': this.props.disabled
                });
                var _a = this.props, label = _a.label, valueIsLocked = _a.valueIsLocked, onLockToggled = _a.onLockToggled, innerComponentProps = __rest(_a, ["label", "valueIsLocked", "onLockToggled"]);
                var id = this.props.id || this.generatedId;
                return React.createElement(React.Fragment, null,
                    React.createElement(fieldLabel_1.FieldLabel, { text: this.props.label, required: this.props.required, for: id },
                        React.createElement(link_1.Link, { className: iconClass, onClick: function () { return _this.props.onLockToggled(!_this.props.valueIsLocked); } })),
                    React.createElement(Component, __assign({}, innerComponentProps, { id: id, disabled: this.props.valueIsLocked || this.props.disabled })));
            };
            return class_1;
        }(React.Component)),
        _a.displayName = recompose_1.wrapDisplayName(Component, 'lockToggle'),
        _a;
}
exports.lockToggle = lockToggle;
